import React from 'react';
import styled from 'styled-components';
import theme from '../../pagesv2/theme';

const STATUS_CONFIG = {
  scheduled:                { label: 'Scheduled',   variant: 'info' },
  joining_call:             { label: 'Joining',     variant: 'info' },
  in_call_recording:        { label: 'Recording',   variant: 'info' },
  done:                     { label: 'Processing',  variant: 'info' },
  downloading:              { label: 'Processing',  variant: 'info' },
  transcribing:             { label: 'Transcribing', variant: 'info' },
  transcription_completed:  { label: 'Analyzing',   variant: 'info' },
  identifying:              { label: 'Analyzing',   variant: 'info' },
  identified:               { label: 'Analyzing',   variant: 'info' },
  needs_triage:             { label: 'Analyzing',   variant: 'info' },
  assigned:                 { label: 'Analyzing',   variant: 'info' },
  analyzing:                { label: 'Analyzing',   variant: 'info' },
  delivered:                { label: 'Ready',       variant: 'success' },
  failed:                   { label: 'Failed',      variant: 'failed' },
  opted_out:                { label: 'Opted Out',   variant: 'failed' },
};

const VARIANT_STYLES = {
  info:    { bg: theme.colors.infoLight,    color: theme.colors.info,    border: theme.colors.info },
  success: { bg: theme.colors.successLight, color: theme.colors.success, border: theme.colors.success },
  failed:  { bg: theme.colors.dangerLight,  color: theme.colors.danger,  border: theme.colors.danger },
};

const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: ${theme.radii.full};
  font-size: ${theme.typography.tiny.size};
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  background: ${p => p.$bg};
  color: ${p => p.$color};
  border: 1px solid ${p => p.$border};
`;

const MeetingStatusBadge = ({ status }) => {
  const config = STATUS_CONFIG[status] || { label: status || 'Unknown', variant: 'info' };
  const styles = VARIANT_STYLES[config.variant];
  return <Badge $bg={styles.bg} $color={styles.color} $border={styles.border}>{config.label}</Badge>;
};

export const getStatusBannerCopy = (status) => {
  switch (status) {
    case 'scheduled':              return 'Murphy will join the meeting at the scheduled time.';
    case 'joining_call':           return 'Murphy is joining the meeting.';
    case 'in_call_recording':      return 'Murphy is in the meeting right now.';
    case 'done':
    case 'downloading':            return 'Murphy is downloading the recording.';
    case 'transcribing':           return 'Murphy is transcribing the meeting — this takes about 10 minutes.';
    case 'transcription_completed':
    case 'identifying':
    case 'identified':             return 'Murphy is identifying participants and analyzing the meeting.';
    case 'needs_triage':           return 'Murphy is identifying who attended this meeting.';
    case 'assigned':
    case 'analyzing':              return 'Murphy is analyzing your meeting — this typically takes 5–10 minutes.';
    case 'failed':                 return 'Something went wrong processing this meeting. The Multiply team has been notified.';
    case 'opted_out':              return 'A participant typed "opt out" in the meeting chat, so Murphy left and deleted the recording. No transcript or feedback will be produced — this is the expected behavior when someone declines recording.';
    default:                       return null;
  }
};

export default MeetingStatusBadge;
